// shared/brand.js
// Single source of truth for brand colors and WhatsApp config.
// Import from this file everywhere — never hardcode colors.

export const brand = {
  primary:     "#B1336E",
  accentGold:  "#E6B43C",
  accentGreen: "#67A43C",
};

export const WA_NUMBER = "51977689676";
export const WA_MSG    = encodeURIComponent("Hola Fast Max, quisiera más información.");
export const WA_HREF   = `https://wa.me/${WA_NUMBER}?text=${WA_MSG}`;

// Framer Motion preset used across sections
export const fadeUp = {
  initial:    { opacity: 0, y: 20 },
  animate:    { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
};